var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras.titleBar.display == 1)?_c('div',{staticClass:"module-title wap"},[(_vm.extras.titleBar.title != 'hide')?_c('div',{staticClass:"title",style:({
      background:
        _vm.extras.titleBar.colorOrBg == 'color' ? _vm.extras.titleBar.color : '',
      color:
        _vm.extras.titleBar.title == 'custom' ? _vm.extras.titleBar.fontColor : '',

      'font-style':
        _vm.extras.titleBar.title == 'custom'
          ? _vm.extras.titleBar.fontTilt == 'on'
            ? 'italic'
            : 'normal'
          : '',
      'font-Weight':
        _vm.extras.titleBar.title == 'custom'
          ? _vm.extras.titleBar.fontWeight == 'on'
            ? '900'
            : ''
          : '',
    })},[_c('span',[_vm._v(_vm._s(_vm.title))]),(_vm.extras.titleBar.colorOrBg == 'src')?_c('img',{staticClass:"title-bg",attrs:{"src":_vm.extras.titleBar.colorOrBg == 'src' ? _vm.extras.titleBar.src : '',"alt":""}}):_vm._e()]):_vm._e(),(_vm.extras.titleBar.subTitle != 'hide')?_c('div',{staticClass:"en",style:({
      color:
        _vm.extras.titleBar.subTitle == 'custom'
          ? _vm.extras.titleBar.fontColor2
          : '',

      'font-style':
        _vm.extras.titleBar.subTitle == 'custom'
          ? _vm.extras.titleBar.fontTilt2 == 'on'
            ? 'italic'
            : 'normal'
          : '',
      'font-Weight':
        _vm.extras.titleBar.subTitle == 'custom'
          ? _vm.extras.titleBar.fontWeight2 == 'on'
            ? '900'
            : ''
          : '',
    })},[_vm._v(" "+_vm._s(_vm.en)+" ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }